import { trustBadges } from "@/mocks/categories";

export default function TrustBadges() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-accent-100/60">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {trustBadges.map((badge) => (
            <div key={badge.label} className="flex items-center gap-3 justify-center">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className={`${badge.icon} text-lg text-accent-500`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}